import { render, staticRenderFns } from "./RdsAlert.vue?vue&type=template&id=236e73ee&scoped=true&"
import script from "./RdsAlert.vue?vue&type=script&lang=js&"
export * from "./RdsAlert.vue?vue&type=script&lang=js&"
import style0 from "./RdsAlert.vue?vue&type=style&index=0&id=236e73ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e73ee",
  null
  
)

export default component.exports